import { render, staticRenderFns } from "./None.vue?vue&type=template&id=5012a9fd&scoped=true"
import script from "./None.vue?vue&type=script&lang=js"
export * from "./None.vue?vue&type=script&lang=js"
import style0 from "./None.vue?vue&type=style&index=0&id=5012a9fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5012a9fd",
  null
  
)

export default component.exports